import { PropsWithChildren } from 'react';
import { Heading } from '../heading';
import { Icon, IconName } from '../icons';
import {
  ActionButton,
  ActionWrapper,
  CloseIconWrapper,
  HorizontalToastWrapper,
  SpacingWrapper,
  TextIconWrapper,
  ToastText,
  ToastWrapper,
  VerticalToastHeader,
  VerticalToastWrapper
} from './styled';

export type Variant = 'horizontal' | 'vertical';
export type Type = 'warning';

/**
 * @deprecated This type is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */
export type SingleToast = PropsWithChildren<{
  id?: number;
  variant?: Variant;
  type?: Type;
  fullWidth?: boolean;
  removeSpacing?: boolean;
  closeable?: boolean;
  icon?: IconName;
  onClose?: () => void;
  action?: {
    label: string | React.ReactElement;
    click: () => void;
  };
  header?: string | React.ReactElement;
}>;

/**
 * @deprecated This component is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */
export function Toast(toast: SingleToast): JSX.Element | null {
  const { variant = 'horizontal', fullWidth, type, removeSpacing } = toast;

  return (
    <ToastWrapper
      fullWidth={fullWidth}
      type={type}
      removeSpacing={removeSpacing}
    >
      {variant === 'horizontal' ? (
        <HorizontalToast toast={toast} />
      ) : (
        <VerticalToast toast={toast} />
      )}
    </ToastWrapper>
  );
}

function HorizontalToast({ toast }: { toast: SingleToast }): JSX.Element {
  const { icon, children, action, closeable = true, onClose } = toast;

  return (
    <HorizontalToastWrapper>
      <TextIconWrapper variant="horizontal">
        {icon && <Icon name={icon} />}
        <ToastText>{children}</ToastText>
      </TextIconWrapper>
      <ActionWrapper>
        {action && (
          <ActionButton onClick={action.click}>{action.label}</ActionButton>
        )}
        {closeable && (
          <CloseIconWrapper onClick={onClose}>
            <Icon name={IconName.Close} />
          </CloseIconWrapper>
        )}
      </ActionWrapper>
    </HorizontalToastWrapper>
  );
}

function VerticalToast({ toast }: { toast: SingleToast }): JSX.Element {
  const { icon, children, action, closeable = true, header, onClose } = toast;
  return (
    <VerticalToastWrapper>
      <VerticalToastHeader>
        <TextIconWrapper>
          {icon && <Icon name={icon} />}
          <Heading variant="h5">{header}</Heading>
        </TextIconWrapper>
        {closeable && (
          <CloseIconWrapper onClick={onClose}>
            <Icon name={IconName.Close} />
          </CloseIconWrapper>
        )}
      </VerticalToastHeader>
      <SpacingWrapper>{children}</SpacingWrapper>
      {action && (
        <SpacingWrapper>
          <ActionButton onClick={action.click} topMargin>
            {action.label}
          </ActionButton>
        </SpacingWrapper>
      )}
    </VerticalToastWrapper>
  );
}
